import React from 'react';
import { Box, Grid, Typography } from 'housecall-ui';

import { InitCustomerPortalParams } from '../../components/InitApp/types';

type Props = {
  customerPortalParams: InitCustomerPortalParams;
};

type DataProps = {
  label: string;
  value: string;
  dataTestId: string;
};

const Data = (props: DataProps) => (
  <Grid item md={6} xs={12}>
    <Box>
      <Typography variant="body2">{props.label}</Typography>
    </Box>
    <Box mb={2} pr={2}>
      <Typography variant="subtitle1" data-testid={props.dataTestId}>
        {props.value}
      </Typography>
    </Box>
  </Grid>
);

export const ExistingCustomerFields = ({ customerPortalParams }: Props) => {
  const {
    contactDetails: { lastName, firstName, phone, email },
  } = customerPortalParams;
  return (
    <Box mt={2}>
      <Grid container spacing={1}>
        <Data label="First and last name" value={`${firstName} ${lastName}`} dataTestId="online-booking-contact-name" />
        <Data label="Phone number" value={phone} dataTestId="online-booking-contact-phone" />
        <Data label="Email" value={email} dataTestId="online-booking-contact-email" />
      </Grid>
    </Box>
  );
};
